import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import style from './style.module.css';

export const ResendLink = ({ onClick = noop, isDisabled = false, wasResendSuccessful }) => {
  if (wasResendSuccessful === undefined) {
    return (
      <div className={style.resend}>
        <Button disabled={isDisabled} onClick={onClick} theme='link'>
          <FormattedMessage defaultMessage='Resend Code' description='phoneVerifyModal.resendCode' id='k3BgfK' />
        </Button>
      </div>
    );
  }

  if (wasResendSuccessful) {
    return (
      <div className={style.resend}>
        <FormattedMessage defaultMessage='Code Resent!' description='phoneVerifyModal.resendSuccess' id='y05qDB' />
      </div>
    );
  }

  return (
    <div className={classnames(style.error, style.resend)}>
      <FormattedMessage defaultMessage='Resend Failed. Try Again.' description='phoneVerifyModal.resendFailed' id='fAvFI6' />
    </div>
  );
};

ResendLink.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  wasResendSuccessful: PropTypes.bool,
};
